import axios from 'axios';
import { API_URL, getAuthHeader } from '.';
import { NewsletterDto } from '../Models/NewsletterDto';

class NewsletterApi {
  static getAll() {
    return axios.get<NewsletterDto[]>(
      `${API_URL}/api/newsletters`,
      getAuthHeader()
    );
  }

  static getById(id: number) {
    return axios.get<NewsletterDto>(
      `${API_URL}/api/newsletters/${id}`,
      getAuthHeader()
    );
  }

  static createOrUpdate(model: NewsletterDto) {
    if (model.id) {
      return axios.put(
        `${API_URL}/api/newsletters/${model.id}`,
        model,
        getAuthHeader()
      );
    } else {
      return axios.post(`${API_URL}/api/newsletters`, model, getAuthHeader());
    }
  }

  static delete(id: number) {
    return axios.post(
      `${API_URL}/api/newsletters/delete/${id}`,
      {},
      getAuthHeader()
    );
  }
  static sendNow(id: number, remaining = false) {
    return axios.post(
      `${API_URL}/api/newsletters/sendNow/${id}?remaining=${remaining}`,
      {},
      getAuthHeader()
    );
  }

  static send(id: number) {
    return axios.post(
      `${API_URL}/api/newsletters/send/${id}`,
      {},
      getAuthHeader()
    );
  }

  static sendTestEmail(id: number) {
    return axios.post(
      `${API_URL}/api/newsletters/send-test/${id}`,
      {},
      getAuthHeader()
    );
  }
}

export default NewsletterApi;
